import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
import './InstagramPost.css';

const InstagramPost = ({ postUrl }) => {
  // Extraer el código del post
  const getPostCode = () => {
    try {
      const match = postUrl.match(/\/p\/([^/?]+)/);
      return match ? match[1] : null;
    } catch (error) {
      console.error('Error parsing Instagram URL:', error);
      return null;
    }
  };

  const postCode = getPostCode();
  const embedUrl = postCode ? `https://www.instagram.com/p/${postCode}/embed` : null;

  if (!embedUrl) return null;

  return (
    <section className="instagram-post-section">
      <motion.div
        className="instagram-post-container"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <div className="instagram-post-header">
          <Instagram size={28} />
          <h3 className="instagram-post-title">Síguenos en Instagram</h3>
        </div>
        <div className="instagram-post-wrapper">
          <iframe
            src={embedUrl}
            className="instagram-post-iframe"
            frameBorder="0"
            scrolling="no"
            allowTransparency="true"
            allow="encrypted-media"
            title="Instagram Post"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default InstagramPost;
